// Instance
import AuthAPI from '@/app/apis/auth/auth-api.js';

// Endpoints
import { AUTH, AUTH_ENDPOINTS } from '@/app/apis/auth/_connection/auth-connection-api.js';

class AuthForgotPasswordAPI extends AuthAPI {
    /**
     * @param {*} userDetails - Contains email and Resume link
     */
    async postAuthForgotPass(userDetails) {
		return AUTH.post(AUTH_ENDPOINTS.POST_FORGOT, userDetails);
    }
}
  
export default new AuthForgotPasswordAPI();
  